import Vue from 'vue';
import VueRouter from 'vue-router'
Vue.use(VueRouter);

import Home from '../pages/index.vue'
import Login from '../components/Login/index.vue'
import ForgetPass from '../components/forgetPass/index.vue'
import SetPass from '../components/SetPassword/index.vue'


let router = new VueRouter({
    routes: [{
        path: '/',
        component: Home
    }, {
        path: '/home',
        component: Login
    }, {
        path: '/forgetpass',
        component: ForgetPass
    }, {
        path: '/setpass',
        component: SetPass
    }]
})
export default router;